import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.link/78pbs3" target="_blank" rel="noopener noreferrer" className="fixed bottom-[100px] md:bottom-6 right-6 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 z-50 group" aria-label="Contactar por WhatsApp" data-id="element-275">
      <MessageCircle className="w-8 h-8 text-white fill-white" data-id="element-276" />
      <span className="absolute right-full mr-3 bg-white text-black text-xs font-bold px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-277">
        ¿Dudas? Escribinos
      </span>
    </a>;
}